import React from "react";
import AriaModal from "react-aria-modal";
import { mdiClose } from "@mdi/js";

import Icon from "../icon";

function Panel({ mounted, unmounting, close, title, maxWidth, children }) {
  return (
    <>
      <AriaModal
        titleText="menuPanel"
        onExit={close}
        underlayStyle={{ backgroundColor: "rgba(0, 0, 0, 0.25)" }}
        dialogStyle={{
          right: 0,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          minHeight: "100%",
          pointerEvents: "none"
        }}
        mounted={mounted}
      >
        <div
          css={`
            position: absolute;
            top: 0;
            right: 100%;
            bottom: 0;
            width: 100%;
            max-width: 512px;
            background-color: ${props => props.theme.colors.bg.default};
            overflow: hidden;
            pointer-events: all;
            animation: mountMenu 300ms ease-out forwards;

            &.unmounting {
              animation: unmountMenu 300ms ease-out forwards;
            }

            @keyframes mountMenu {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(100%);
              }
            }

            @keyframes unmountMenu {
              0% {
                transform: translateX(100%);
              }
              100% {
                transform: translateX(0);
              }
            }
          `}
          className={unmounting ? "unmounting" : ""}
        >
          <button
            onClick={close}
            css={`
              position: absolute;
              top: 20px;
              right: 20px;
              z-index: 1;
              width: 32px;
              height: 32px;
              margin: 0;
              padding: 0;
              border: 0;
              border-radius: 9999px;
              color: ${props => props.theme.colors.text.default};
              background: transparent;
              box-shadow: none;
              cursor: pointer;
              :focus {
                outline: 0;
              }
            `}
          >
            <Icon
              symbol={mdiClose}
              size={1.5}
              color="currentColor"
              css={`
                position: absolute;
                top: 50%;
                left: 50%;
                vertical-align: top;
                transform: translate(-50%, -50%);
              `}
            />
          </button>
          {children}
        </div>
      </AriaModal>
    </>
  );
}

export default Panel;
